import { render } from "./FormUploadImage.vue?vue&type=template&id=57cd6cf3&scoped=true"
import script from "./FormUploadImage.vue?vue&type=script&lang=js"
export * from "./FormUploadImage.vue?vue&type=script&lang=js"

import "./FormUploadImage.vue?vue&type=style&index=0&id=57cd6cf3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cd6cf3"]])

export default __exports__